import "./style.css";
import layout from "./layout.html";
import chapters from "@data/chapters.json";
import Cover from "@blocks/Cover";
import Block1 from "@blocks/Block1";
import Block2 from "@blocks/Block2";
import Block3 from "@blocks/Block3";
import Block4 from "@blocks/Block4";
import Block5 from "@blocks/Block5";
import Block6 from "@blocks/Block6";
import Block7 from "@blocks/Block7";
import Block8 from "@blocks/Block8";
import Block9 from "@blocks/Block9";
import Block10 from "@blocks/Block10";

export default class Chapters {
  static selector = ".chapters";

  constructor(block) {
    this.block = block;

    this.block.innerHTML = layout;

    this.chapterTemplate = this.block.querySelector(
      "template.chapter-template"
    );

    this.chapterChangedCallbacks = [];

    this.classesMap = {
      "block-1": Block1,
      "block-2": Block2,
      "block-3": Block3,
      "block-4": Block4,
      "block-5": Block5,
      "block-6": Block6,
      "block-7": Block7,
      "block-8": Block8,
      "block-9": Block9,
      "block-10": Block10,
    };
  }

  onReady() {
    return new Promise(async (resolve, reject) => {
      this.mounted = true;

      await Promise.all(
        Object.values(chapters).map(async (chapter) => {
          const chapterNode =
            this.chapterTemplate.content.firstElementChild.cloneNode(true);
          chapterNode.id = `chapter-${chapter.cover.title.number}`;
          if (chapter.color) {
            chapterNode.dataset.headerColor = chapter.color;
          }

          const coverNode = chapterNode.querySelector(".cover");
          await new Cover(coverNode, chapter.cover).onReady();
          if (chapter.cover.color) {
            coverNode.dataset.headerColor = chapter.cover.color;
          }

          const blocksWrapperNode = chapterNode.querySelector(
            ".chapter__content__blocks"
          );

          const numberNode = chapterNode.querySelector(
            ".chapter__content__info__number"
          );
          numberNode.textContent = `Capitolo 0${chapter.cover.title.number}`;

          const titleNode = chapterNode.querySelector(
            ".chapter__content__info__title"
          );
          titleNode.textContent = chapter.cover.title.text;

          chapter.blocks.map(async (block) => {
            const { name, attrs } = block;
            const blockNode = document.createElement("DIV");
            blockNode.classList.add(name);
            if (block.color) {
              blockNode.dataset.headerColor = block.color;
            }
            blocksWrapperNode.appendChild(blockNode);

            await new this.classesMap[name](blockNode, attrs).onReady();
          });

          chapterNode.dataset.headerInViewId = chapter.cover.title.number;
          this.block.appendChild(chapterNode);

          const chapterContentNode =
            chapterNode.querySelector(".chapter__content");
          if (chapter.backgroundColor) {
            chapterContentNode.classList.add(`bg-${chapter.backgroundColor}`);
          }
          if (chapter.textColor) {
            chapterContentNode.classList.add(`c-${chapter.textColor}`);
          }
          if (chapter.blocks.length > 0) {
            chapterContentNode.dataset.chapterNumber = `${chapter.cover.title.number}`;
          } else {
            chapterContentNode.remove();
          }
        })
      );

      resolve();
    });
  }

  onComplete = () => {};

  onResize() {}

  onDestroy() {}
}
